import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-detail',
  templateUrl: './exam-detail.component.html',
  styleUrls: ['./exam-detail.component.scss']
})
export class ExamDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
